import { CommonModule } from '@angular/common';
import { Component, DestroyRef, EventEmitter, HostListener, inject, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Ticket, toNumber, GameTicketQuery, TICKET_TRANSFER_STATUS } from '@fgb/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CountdownV2Component } from '@fgb/portal-component-library/src/lib/shared/countdown-v2';

@Component({
  selector: 'fgbcl-ticket-transfer-status',
  standalone: true,
  imports: [CommonModule, CountdownV2Component, FGBSharedModule],
  templateUrl: './ticket-transfer-status.component.html',
  styleUrl: './ticket-transfer-status.component.scss'
})
export class TicketTransferStatusComponent implements OnInit{
  private gameTicketQuery = inject(GameTicketQuery);
  private route = inject(ActivatedRoute);
  ticket: Ticket | undefined; 
  customerTicket: any;
  ticketStatus = TICKET_TRANSFER_STATUS;
  status: TICKET_TRANSFER_STATUS;
  showStatus: boolean = false; 
  displayVertical: boolean = false;
  private destroyRef = inject(DestroyRef);
  @Output() onRefresh: EventEmitter<void> = new EventEmitter<void>();
  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this._checkDisplayOrientation();
  }

  ngOnInit(): void {
    const id = toNumber(this.route.snapshot.paramMap.get('gameNumber'));
    this.gameTicketQuery.selectGameDetailsByGameNumber(id).pipe(
      takeUntilDestroyed(this.destroyRef)
    )
    .subscribe(({ game, ticket, status, isPastGame }) => {
      this.customerTicket = game;
      this.ticket = ticket;
      this.status = status;
      this.showStatus = !isPastGame;
      this._checkDisplayOrientation();
    });
  }

  private _checkDisplayOrientation(): void {
    const width = window.innerWidth;
    if( width <= 448 && this.customerTicket ){
      const homeTeamName = this.customerTicket.TeamNames?.HomeTeamName?.length || 0;
      const awayTeamName = this.customerTicket.TeamNames?.AwayTeamName?.length || 0;
      this.displayVertical = homeTeamName + awayTeamName > 35;
    }else{
      this.displayVertical = false;
    }
  }

}
